<template>
  <page-outline :title="pageTitle">
    <!-- Bouton retour dans primaryActions -->
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    
    <template slot="pageContent">
      <b-container fluid>
        <ca-form-global :mode="mode" :id="id"  :readonly="!isEditable" @bottomActions="handleBottomActions"></ca-form-global>
      </b-container>
    </template>
    
    <!-- Slot bottomActions pour PageOutline -->
    <template slot="bottomActions">
      <div v-if="bottomActionsData.show" class="d-flex justify-content-end flex-wrap" style="gap: 0.75rem;">
        <component 
          v-for="(action, index) in bottomActionsData.actions" 
          :key="index"
          :is="action.component"
          v-bind="action.props"
          @click="action.handler">
        </component>
      </div>
    </template>
  </page-outline>
</template>
<script>

import CAFormGlobal from "@/pages/security/CAFormGlobal.vue"
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'CAForm',
  components: {
    'ca-form-global':CAFormGlobal,
    'page-outline': PageOutline,
    AppButton,

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data: () => {
    return {
      formType: 'add',
      pageTitle: '',
      returnUrl: '/security/-1',
      bottomActionsData: {
        show: false,
        actions: []
      }
    }
  },
  created () {
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_ca')
  },
  methods: {
    goBack() {
      loadPage(this, {url: this.returnUrl})
    },
    handleBottomActions(actionsData) {
      this.bottomActionsData = actionsData
    }
  }
}

</script>
